import React from 'react';
import classes from './Contact.module.css';
import Social from '../UI/Social/Social';
import ScrollDown from '../UI/ScrollDownIndicator/ScrollDown';
import Header from '../UI/Header/Header';
import ContactShapes from '../UI/Shapes/ContactShapes';
import Canvas from '../Canvas/Canvas';

const Contact = () => {
  return (
    <>
      <section style={{ zIndex: 2 }} className={classes.contact}>
        <Canvas />
        <Header header="CONTACT" styles={classes['contact-text']} />
        <ScrollDown link="#contact" />
      </section>

      <section id="contact" className={classes.social_section}>
        <ContactShapes style={{ zIndex: 0 }} />

        <div className={classes.social_contacts}>
          {/* <h1 className={classes.social_msg}>
            Who doesn’t love a totally strange message from a stranger about
            something completely random?
          </h1> */}
          <h1 className={classes.scoial_contacts_header}>Forms are boring!</h1>
          <h4 className={classes.scoial_contacts_para}>Stalk me here then!</h4>
          {/* <a
            href="mailto:omgawandeofficial9834899149@gmail.com"
            className={classes.social_number}
          >
            omgawandeofficial9834899149@gmail.com
          </a> */}
        </div>
        <Social y="10" width="80px" />
      </section>
    </>
  );
};

export default Contact;
